import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchSwingImages } from '@data';

export const getSwingImagesKey = (uuid: string) => ['swings', uuid, 'images'] as const;

/**
 * Fetch images for a swing. The beast listener overrides the cache for this query.
 * We can rely on the cache and there is no need to refetch it.
 */
export const useSwingImages = (uuid = '') => {
    return useQuery({
        queryKey: getSwingImagesKey(uuid),
        queryFn: () => fetchSwingImages(supabaseClient, uuid),
        enabled: Boolean(uuid),
        retry: true,
        // Once the query is successful we no longer need to query it.
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });
};
